import { memo } from 'react';
import NumberField from '@components/text-field/NumberField';



interface SizeItemProps {
	label: string,
	count: number,
	onClick: (label: string, value: number) => void,
}


const SizeItem = (props: SizeItemProps): JSX.Element => {
	const { label, count, onClick } = props;

	return (
		<NumberField
			label={label}
			rounded={true}
			value={count === 0 ? undefined : count}
			valueUnits='ks'
			placeholder='ks'
			maxNumber={100}
			onChange={value => value ? onClick(label, value) : onClick(label, 0)} />
	);
}

export default memo(SizeItem);